import { render, staticRenderFns } from "./historical.vue?vue&type=template&id=e0e5b95a&scoped=true"
import script from "./historical.vue?vue&type=script&lang=js"
export * from "./historical.vue?vue&type=script&lang=js"
import style0 from "./historical.vue?vue&type=style&index=0&id=e0e5b95a&lang=scss"
import style1 from "./historical.vue?vue&type=style&index=1&id=e0e5b95a&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e0e5b95a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\project\\yl\\yl-web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e0e5b95a')) {
      api.createRecord('e0e5b95a', component.options)
    } else {
      api.reload('e0e5b95a', component.options)
    }
    module.hot.accept("./historical.vue?vue&type=template&id=e0e5b95a&scoped=true", function () {
      api.rerender('e0e5b95a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/data-query/components/historical.vue"
export default component.exports